import { CommonModule } from '@angular/common'
import { HTTP_INTERCEPTORS } from '@angular/common/http'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'
import { NgSelectModule } from '@ng-select/ng-select'
import {
  FeaturesConfigModule,
  HttpModule,
  I18nModule,
  provideDefaultConfig,
  UrlModule,
  UserAddressService
} from '@spartacus/core'
import { ProductVariantsModule } from '@spartacus/product/variants'
import { ProductVariantStyleIconsModule } from '@spartacus/product/variants/root'
import {
  ActiveFacetsModule,
  CardModule,
  FacetListModule,
  FormErrorsModule,
  IconModule,
  ItemCounterModule,
  KeyboardFocusModule,
  ListNavigationModule,
  MediaModule,
  OutletModule,
  OutletRefModule,
  PageComponentModule,
  SpinnerModule,
  StarRatingModule
} from '@spartacus/storefront'
import { AddressFormModule } from '@spartacus/user/profile/components'
import { NgxCaptchaModule } from 'ngx-captcha'
import { InfiniteScrollModule } from 'ngx-infinite-scroll'
import { FileService } from '../services/file.service'
import { ProductDetailsService } from '../services/product.service'
import { CustomInterceptor } from './interceptors/interceptor'
import { defaultAddCommentsPhotoLayoutConfig } from './myAccount/credit-claims/add-comments-photo-layout.config'
import { MyAccountModule } from './myAccount/my-account.module'
import { CustomSearchBoxModule } from './navigation/custom-navigation.module'
import { CustomCardModule } from './shared/card/card.module'
import { CustomAnnouncementBannerModule } from './shared/custom-announcement-banner/custom-announcement-banner.module'
import { MaterialModule } from './shared/material.module'
import { SharedModule } from './shared/shared.module'

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    IconModule,
    RouterModule,
    UrlModule,
    MediaModule,
    IconModule,
    IconModule,
    OutletModule,
    OutletRefModule,
    PageComponentModule,
    SpinnerModule,
    ItemCounterModule,
    FeaturesConfigModule,
    ListNavigationModule,
    ProductVariantsModule,
    StarRatingModule,
    InfiniteScrollModule,
    NgbModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    FacetListModule,
    ActiveFacetsModule,
    KeyboardFocusModule,
    CardModule,
    AddressFormModule,
    FormErrorsModule,
    NgxCaptchaModule,
    NgSelectModule,
    CustomSearchBoxModule,
    MyAccountModule,
    SharedModule,
    CustomCardModule,
    HttpModule,
    ProductVariantStyleIconsModule,
    CustomAnnouncementBannerModule
  ],
  exports: [],
  providers: [
    ProductDetailsService,
    FileService,
    UserAddressService,
    { provide: HTTP_INTERCEPTORS, useClass: CustomInterceptor, multi: true },
    provideDefaultConfig(defaultAddCommentsPhotoLayoutConfig)
  ]
})
export class FeaturesModule {}
